// Click target only — the drawn track is 48x24 at every size.
export const toggleSizes = {
	large: 'large',
	compact: 'compact',
	min: 'min',
} as const;

export type ToggleSize = typeof toggleSizes[keyof typeof toggleSizes];
